<div
    [nbSpinner]="loading"
    style="min-height: 200px"
    [style]="{
        'min-height': '200px',
        display: !loading && !categories?.masculino && !categories?.feminino && !categories?.mista ? 'none' : 'block'
    }"
>
    <nb-tabset>
        <p
            class="paragraph-2 text-uppercase mr-2 mb-0"
            ngProjectAs="nb-tab"
            *ngIf="categories?.masculino || categories?.feminino || categories?.mista"
        >
            Categorias:
        </p>
        <nb-tab tabTitle="{{ 'GENERAL.MALE' | translate }}" *ngIf="categories?.masculino" active>
            <ng-container
                *ngTemplateOutlet="categoriesTemplate; context: { categories: categories.masculino }"
            ></ng-container>
        </nb-tab>
        <nb-tab tabTitle="{{ 'GENERAL.FEMININE' | translate }}" *ngIf="categories?.feminino" [active]="!categories?.masculino">
            <ng-container
                *ngTemplateOutlet="categoriesTemplate; context: { categories: categories.feminino }"
            ></ng-container
        ></nb-tab>
        <nb-tab tabTitle="{{ 'GENERAL.MIXED' | translate }}" *ngIf="categories?.mista">
            <ng-container
                *ngTemplateOutlet="categoriesTemplate; context: { categories: categories.mista }"
            ></ng-container
        ></nb-tab>
    </nb-tabset>
</div>

<ng-template #categoriesTemplate let-categories="categories">
    <nb-card *ngFor="let category of categories">
        <nb-card-body>
            <div class="d-flex">
                <nb-radio-group (valueChange)="onSelectionChange.emit($event)">
                    <nb-radio
                        [value]="category.id_categoria"
                        [ngClass]="{ hideRadio: !selection }"
                        [disabled]="category.inscrever.disabled"
                    >
                        <div class="d-flex flex-column">
                            <span>{{ category.descricao }}</span>
                            <span class="text-hint">
                                {{ "GENERAL.SUBSCRIBE-UNTIL" | translate }} {{ category.inscrever_ate }}
                            </span>
                        </div>
                    </nb-radio>
                </nb-radio-group>
            </div>
            <div class="category-info-list">
                <div class="category-info">
                    <p>{{ category.qtd_confirmada }} {{ "GENERAL.SUBSCRIBERS" | translate }}</p>
                    <nb-icon icon="people-outline"></nb-icon>
                </div>
                <div class="divider vertical d-none d-md-block"></div>
                <div class="category-info">
                    <button nbButton size="tiny" ghost (click)="navigateToCategory(category.id_categoria)">
                        {{ "PAGES.CATEGORY-DETAILS" | translate }} <nb-icon icon="eye-outline"></nb-icon>
                    </button>
                </div>
            </div>
        </nb-card-body>
    </nb-card>
</ng-template>
